import {
	ChangeDetectionStrategy,
	Component,
	input,
	output,
} from '@angular/core';
import { FormControl } from '@angular/forms';

import { TranslatePipe } from '@ngx-translate/core';

import { InputComponent } from '@valk-nx/components/ui-input/src/lib/input';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: `vp-filter-numeric`,
	templateUrl: './filter-numeric.html',
	imports: [InputComponent, TranslatePipe],
})
export class FilterNumericComponent {
	inputId = input.required<string>();
	minValue = input<number>(1);
	maxValue = input<number>();
	value = input<string>('');

	changed = output<string>();

	formControl = new FormControl('');

	commit(): void {
		const enteredValue = (this.formControl.value ?? '').toString().trim();
		const numericValue = Number(enteredValue);

		// An empty or non-numeric input clears the filter
		if (!enteredValue || Number.isNaN(numericValue)) {
			this.formControl.setValue('');
			if (this.value() !== '') {
				this.changed.emit('');
			}
			return;
		}

		const clampedValue = Math.min(
			Math.max(numericValue, this.minValue()),
			this.maxValue() ?? Infinity,
		);

		const nextValue = clampedValue.toString();
		this.formControl.setValue(nextValue);

		if (nextValue !== this.value()) {
			this.changed.emit(nextValue);
		}
	}
}
